import React from 'react';
import translations from "../../../utils/language/translations.json";
import { useTranslation } from "react-i18next";

const Shipping = () => {
  const { t: translate, i18n } = useTranslation();
  const currentLang = i18n.language;
  const t = (key) => translations.Shipping[key][currentLang];

  return (
    <section className="grid">
      <div className="contentfront">
        <div className="page-content shipping-page">
          <h1>📦 {t("title")}</h1>
          <p>{t("intro")}</p>

          <div className="highlight-box">
            <h2>{t("templateTitle")}</h2>
            <p>{t("templateText")}</p>

            <ul className="styled-bullets">
              <li>{t("lowTier")}</li>
              <li>{t("midTier")}</li>
              <li>{t("highTier")}</li>
            </ul>

            <h2>{t("bestPracticesTitle")}</h2>
            <ul className="styled-bullets">
              <li>{t("useTracking")}</li>
              <li>{t("protectCard")}</li>
              <li>{t("communicate")}</li>
            </ul>

            <h2>{t("noteTitle")}</h2>
            <p>{t("noteText")}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Shipping;
